import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import {GetListResponse, GetResponse} from "@/src/modules/core/types";
import axios from "@/src/modules/core/lib/axios";

import {
  Company,
  CompanyConfig,
  CompanyConfigForCreate,
  CompanyDetail,
  CompanyDetailForCreate,
  CompanyDetailType,
  CompanyRequest,
} from "../types";

class CompanyApi extends CoreApi {
  getCompany(): Promise<AxiosResponse<GetResponse<Company>>> {
    return this.get("company");
  }

  getCompanyById(id: number): Promise<AxiosResponse<GetResponse<Company>>> {
    return super.getById("companies", id);
  }

  updateCompany(data: CompanyRequest): Promise<AxiosResponse<GetResponse<Company>>> {
    return axios({
      url: "company",
      method: "patch",
      data,
    });
  }

  getConfigs(companyId: number): Promise<AxiosResponse<GetListResponse<CompanyConfig>>> {
    return this.get(`companies/${companyId}/configs`);
  }

  createConfig(
    companyId: number,
    data: CompanyConfigForCreate,
  ): Promise<AxiosResponse<GetResponse<CompanyConfig>>> {
    return super.create(`companies/${companyId}/configs`, data);
  }

  updateConfig(
    companyId: number,
    configId: number,
    data: CompanyConfigForCreate,
  ): Promise<AxiosResponse<GetResponse<CompanyConfig>>> {
    return super.update(`companies/${companyId}/configs`, configId, data);
  }

  deleteConfig(
    companyId: number,
    configId: number,
  ): Promise<AxiosResponse<void>> {
    return super.delete(`companies/${companyId}/configs`, configId);
  }

  getDetails(companyId: number): Promise<AxiosResponse<GetListResponse<CompanyDetail>>> {
    return this.get(`companies/${companyId}/details`);
  }

  createDetail(
    companyId: number,
    data: CompanyDetailForCreate,
  ): Promise<AxiosResponse<GetResponse<CompanyDetail>>> {
    return super.create(`companies/${companyId}/details`, data);
  }

  updateDetail(
    companyId: number,
    detailId: number,
    data: CompanyDetailForCreate,
  ): Promise<AxiosResponse<GetResponse<CompanyDetail>>> {
    return super.update(`companies/${companyId}/details`, detailId, data);
  }

  deleteDetail(
    companyId: number,
    detailId: number,
  ): Promise<AxiosResponse<void>> {
    return super.delete(`companies/${companyId}/details`, detailId);
  }

  getCompanyDetailTypes(): Promise<
    AxiosResponse<{company_detail_types: CompanyDetailType[]}>
  > {
    return this.get("company_detail_types");
  }
}

export const companyApi = new CompanyApi();

